import { Component, Mixins } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { mdiDelete } from '@mdi/js'
import store, { Mutations } from '../../store'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import AddRestaurantModal from '@/components/Onboarding/AddRestaurantModal.vue'
import { IOnboardingPayload, IOnboardingRestaurant } from '@/firestore'

@Component({
  components: {AddRestaurantModal}
})
export default class AddRestaurants extends Mixins(IconsMixin, AuthMixin) {
  @State('onboarding') public onboarding!: IOnboardingPayload

  public restaurants: IOnboardingRestaurant[] = []

  public icons = {
    delete: mdiDelete
  }

  public get groupName() {
    return this.onboarding ? this.onboarding.groupName : ''
  }

  public valid: boolean = false

  // modal props
  public showAddRestaurantModal = false
  public selectedRestaurant: IOnboardingRestaurant | null = null
  public selectedRestaurantIndex: number = -1
  public showConfirmRemove = false
  public selectedRestaurantRemoval: IOnboardingRestaurant | null = null
  public modalAction: 'create' | 'update' = 'create'
  public warning: string = ''
  public chargifyInfo = {} as {
    id: string,
    customerId: number,
    subcriptionId: number,
    componentId: number,
    componentQty: number,
    iat: number,
    exp: number
  }

  public async mounted() {
    this.restaurants = [...this.onboarding.restaurants]
  }

  public addRestaurant() {
    if (this.restaurants.length < this.onboarding.restaurantLimit) {
      this.selectedRestaurant = {
        name: '',
        identifier: '',
        address: {id: ''},
        generalManager: {
          name: '',
          phoneNumber: ''
        },
        chef: {
          name: '',
          phoneNumber: ''
        }
      }
      this.selectedRestaurantIndex = -1
      this.modalAction = 'create'
      this.showAddRestaurantModal = true
    } else {
      this.warning = 'You have reached the maximum number of restaurants in your subscription plan'
    }
  }

  public modifyRestaurant(restaurant: IOnboardingRestaurant) {
    this.selectedRestaurant = {...restaurant}
    if (restaurant.generalManager) {
      this.selectedRestaurant.generalManager = {...restaurant.generalManager}
    }
    if (restaurant.chef) {
      this.selectedRestaurant.chef = {...restaurant.chef}
    }
    this.selectedRestaurantIndex = this.restaurants.indexOf(restaurant)
    this.modalAction = 'update'
    this.showAddRestaurantModal = true
  }

  public saveRestaurant() {
    // check here for limit violation
    this.showAddRestaurantModal = false

    if (this.selectedRestaurant) {
      if (this.selectedRestaurantIndex >= 0) {
        this.restaurants[this.selectedRestaurantIndex] = this.selectedRestaurant
      } else {
        this.restaurants.push(this.selectedRestaurant)
      }

      this.commitState()
    }
  }

  public confirmRemoveRestaurant(restaurant: IOnboardingRestaurant) {
    this.selectedRestaurantRemoval = restaurant
    this.showConfirmRemove = true
  }

  public removeRestaurant() {
    this.showConfirmRemove = false
    if (this.selectedRestaurantRemoval) {
      this.restaurants.splice(this.restaurants.indexOf(this.selectedRestaurantRemoval), 1)
      this.commitState()
      this.selectedRestaurantRemoval = null
    }
  }

  public createAdminLogin() {
    this.$router.push({name: 'create-admin-login'})
  }

  private commitState() {
    store.commit(Mutations.UPDATE_ONBOARDING, {
      onboarding: {
        ...this.onboarding,
        restaurants: [...this.restaurants]
      }
    })
  }
}
